import React from 'react';
import PublicPageLayout from '../components/landing-page/PublicPageLayout';
import { faqItems } from '../components/landing-page/faqItems';

export default function FaqPage() {
  return (
    <PublicPageLayout title='FAQ' subtitle='Common questions about pricing experimentation and implementation.'>
      <div className='space-y-4'>
        {faqItems.map((item) => (
          <details key={item.question} className='rounded-lg border border-gray-700 bg-gray-900/40 p-4'>
            <summary className='cursor-pointer text-base font-semibold text-white'>{item.question}</summary>
            <p className='mt-3 text-sm leading-6 text-gray-300'>{item.answer}</p>
          </details>
        ))}
      </div>
    </PublicPageLayout>
  );
}
